import { Unit } from './unit.model';
import { UnitSystem } from './unitsystem.model';

export class SelectedUnits {
  public unitSystem: UnitSystem | null = null;
  public capacity: Unit | null = null;
  public pressure: Unit | null = null;

  public getDefaultSpeedUnit(): Unit | null {
    return this.unitSystem?.units.filter((unit) => unit.category === 'DREHZAHL' && unit.isDefault === true)[0] ?? null;
  }

  public getDefaultPowerUnit(): Unit | null {
    return this.unitSystem?.units.filter((unit) => unit.category === 'LEISTUNG' && unit.isDefault === true)[0] ?? null;
  }

  public getDefaultTorqueUnit(): Unit | null {
    return (
      this.unitSystem?.units.filter((unit) => unit.category === 'DREHMOMENT' && unit.isDefault === true)[0] ?? null
    );
  }

  public getDefaultNPSHRUnit(): Unit | null {
    return (
      this.unitSystem?.units.filter((unit) => unit.category === 'LAENGENMASS' && unit.isDefault === true)[0] ?? null
    );
  }

  public getDefaultLengthDimensionUnit(): Unit | null {
    return (
      this.unitSystem?.units.filter((unit) => unit.category === 'LAENGENMASS' && unit.isDefault === true)[0] ?? null
    );
  }

  public getDefaultPressureUnit(): Unit | null {
    return this.unitSystem?.units.filter((unit) => unit.category === 'DRUCK' && unit.isDefault === true)[0] ?? null;
  }

  public getDefaultViscosityUnit(): Unit | null {
    return (
      this.unitSystem?.units.filter((unit) => unit.category === 'VISKOSITAET' && unit.isDefault === true)[0] ?? null
    );
  }

  public getDefaultDensityUnit(): Unit | null {
    return this.unitSystem?.units.filter((unit) => unit.category === 'DICHTE' && unit.isDefault === true)[0] ?? null;
  }

  public getDefaultVolumetricStreamUnit(): Unit | null {
    return this.unitSystem?.units.filter((unit) => unit.category === 'MENGE' && unit.isDefault === true)[0] ?? null;
  }

  public getPipeInnerDiameterUnit(): Unit | null {
    return {
      id: 12,
      text: 'mm',
      isDefault: true,
      category: 'LAENGENMASS',
      displayName: 'mm',
    };
  }

  public getDefaultVelocityUnit(): Unit | null {
    return {
      id: 23,
      text: 'm/s',
      isDefault: true,
      category: 'GESCHWINDIGKEIT',
      displayName: 'm/s',
    };
  }

  public getDefaultChamberVolumeUnit(): Unit | null {
    return {
      id: 27,
      text: 'cm3',
      isDefault: true,
      category: 'VOLUMEN',
      displayName: 'cm³',
    };
  }

  public getDefaultAxialLoadUnit(): Unit | null {
    return {
      id: 25,
      text: 'N',
      isDefault: true,
      category: 'KRAFT',
      displayName: 'N',
    };
  }

  public isValid(): boolean {
    return this.capacity?.id !== null && this.pressure?.id !== null && this.unitSystem?.id !== '';
  }
}
